module.exports = __webpack_public_path__ + "img/graph.f0addbe5.svg";